export default __webpack_public_path__ + "static/winter21-32adf78261bcc7154a8e9eb11b622089.webp";